export enum Routes {
  HOME = "/",
  DESIGN_EXAMPLES = "/designExamples",
  PALETTE_AND_CODE = "/paletteAndCode",
}
